import { Pipe, PipeTransform } from '@angular/core';
import { correctionBelongsToTitles } from '@app/_shared/constant/correctionBelongsToTitles';

const correctionBelongsToTitle = correctionBelongsToTitles;

@Pipe({
  name: 'belongsToTitle',
  standalone: false, // eslint-disable-line
})
export class BelongsToTitlePipe implements PipeTransform {
  transform(belongsToId: string): string {
    if (belongsToId === null) {
      return '';
    }

    return correctionBelongsToTitle[belongsToId] ?? belongsToId;
  }
}
